/**
 * Announcement Banner JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Announcement Banner component.
 */

( function( app ) {
  const COMPONENT = {
    className: 'announcement-banner',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      window.debounce = require( 'lodash/debounce' );
      const root = $( ':root' );

      function setAnnouncementBannerHeight() {
        const $desktopBanner = $( '#announcement-banner' );
        const $mobileBanner = $( '#announcement-banner__mobile' );

        let height = 0;

        if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
          height = $desktopBanner.is( ':visible' ) ? $desktopBanner.outerHeight() : 0;
        } else {
          height = $mobileBanner.is( ':visible' ) ? $mobileBanner.outerHeight() : 0;
        }

        root.css( '--announcementBannerHeight', `${height}px` );
      }

      function closeAnnouncementBanner( $banner ) {
        $banner.slideUp( 200, function() {
          setAnnouncementBannerHeight();
        } );
      }

      function openAnnouncementBanner( $banner ) {
        $banner.slideDown( 200, function() {
          setAnnouncementBannerHeight();
        } );
      }

      setAnnouncementBannerHeight();

      $( window ).on( 'resize', debounce( function() {
        setAnnouncementBannerHeight();
      }, 100 ) );

      if ( !sessionStorage.getItem( 'announcement-banner-seen' ) ) {
        sessionStorage.setItem( 'announcement-banner-seen', 'false' );
      }

      if ( sessionStorage.getItem( 'announcement-banner-seen' ) === 'false' ) {
        if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
          openAnnouncementBanner( $( '#announcement-banner' ) );
        } else {
          openAnnouncementBanner( $( '#announcement-banner__mobile' ) );
        }
      }

      $( '#announcement-banner__close' ).on( 'click', function() {
        closeAnnouncementBanner( $( '#announcement-banner' ) );
        sessionStorage.setItem( 'announcement-banner-seen', 'true' );
      } );

      $( '#announcement-banner__close-mobile' ).on( 'click', function() {
        closeAnnouncementBanner( $( '#announcement-banner__mobile' ) );
        sessionStorage.setItem( 'announcement-banner-seen', 'true' );
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
